export const hasPageBeenOpenedFromApp = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  // following comes from the Tims app only
  const fromApp = searchParams.get('fromApp') === 'true';
  return fromApp;
};
